import classnames from "classnames";
import { PropsWithChildren } from "react";
import styled from "styled-components";

import Shimmer, { ShimmerProps } from "src/components-v2/Shimmer";

const TableShimmerRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

type ColShimmerProps = Pick<ShimmerProps, "height" | "width" | "radius" | "color" | "className"> & {
  amount?: number;
};

function TableShimmer(): null {
  return null;
}

function RowShimmer({ children, ...props }: PropsWithChildren<{}>) {
  return <TableShimmerRow {...props}>{children}</TableShimmerRow>;
}

function ColShimmer({ amount, height, width, radius, color, className, ...props }: ColShimmerProps) {
  return (
    <>
      {Array.from(Array(amount)).map((_, key) => (
        <div key={key} className={classnames("u-flex-grow", className)} {...props}>
          <Shimmer {...{ height, width, radius, color }} />
        </div>
      ))}
    </>
  );
}

TableShimmer.Row = RowShimmer;
TableShimmer.Col = ColShimmer;

export default TableShimmer;
